import { render, staticRenderFns } from "./InvoiceAirtime.vue?vue&type=template&id=81f5d6b0&scoped=true&"
import script from "./InvoiceAirtime.vue?vue&type=script&lang=js&"
export * from "./InvoiceAirtime.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceAirtime.vue?vue&type=style&index=0&id=81f5d6b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f5d6b0",
  null
  
)

export default component.exports